import React from 'react';
import { render } from 'react-dom';
import { syncHistoryWithStore } from 'react-router-redux';
import Raven from 'raven-js';
import RootContainer from './containers/rootContainer';
import configureStore from './store';
import { getHistoryType } from './actions/sharedActions';

import styl from './stylesheets/main.styl'; // eslint-disable-line

const initialState = window.__INITIAL_STATE__; // eslint-disable-line

if (initialState.sentryDsn) {
  Raven.config(initialState.sentryDsn).install();
}

if (!initialState.accessToken) {
  Raven.captureMessage('Raven Message: Authentication is not present in initial state.');
}

const { historyType } = getHistoryType();

const store = configureStore(initialState);
const history = syncHistoryWithStore(historyType, store);

render(
  <RootContainer history={history} store={store} />,
  document.getElementById('root'),
);

if (module.hot) {
  module.hot.accept();
}
